module.exports = __webpack_public_path__ + "static/media/2.7fed7a5a.png";